import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BcSepIcon     from "../../../asset/images/about/breadcrumb-separator.svg";
import HeroBgImg     from "../../../asset/images/power&surveillance/prime-master/hero-bg.webp";
import HeroMobileImg from "../../../asset/images/power&surveillance/prime-master/hero-bg-mobile.webp";
import PrimeImg      from "../../../asset/images/power&surveillance/prime-master/prime-master.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .pm { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .pm-hero {
    position: relative;
    width: 100%;
    height: 465px;
    overflow: hidden;
    background: #fbe8e7;
  }
  .pm-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .pm-hero-bg-mobile {
    display: none;
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .pm-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .pm-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 800;
    color: #202020;
    line-height: 120%;
    max-width: 524px;
  }
  .pm-hero-title em { font-style: normal; color: #EB2019; }

  /* SUBNAV */
  .pm-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .pm-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
    overflow: visible;
  }
  .pm-subnav-item {
    position: relative;
    flex-shrink: 0;
  }
  .pm-subnav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .pm-subnav-link.pm-active { font-weight: 500; }
  .pm-subnav-link:hover { background: rgba(0,0,0,0.15); }
  .pm-subnav-chevron {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid rgba(255,255,255,0.9);
    border-bottom: 2px solid rgba(255,255,255,0.9);
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .pm-subnav-chevron.open { transform: rotate(-135deg) translateY(-2px); }

  /* DROPDOWN — position:absolute */
  .pm-subnav-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 312px;
    background: #fff;
    border: 1px solid #7A7A7A;
    z-index: 9999;
  }
  .pm-subnav-dropdown-item {
    display: block;
    padding: 15px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    text-decoration: none;
    border-bottom: 1px solid #EB2019;
    transition: background 0.15s;
    cursor: pointer;
  }
  .pm-subnav-dropdown-item:last-child { border-bottom: none; }
  .pm-subnav-dropdown-item:hover { background: #f9f9f9; color: #EB2019; }
  .pm-subnav-dropdown-item.pm-dd-active { color: #EB2019; font-weight: 500; }

  /* MOBILE BAR */
  .pm-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .pm-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .pm-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .pm-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* MOBILE SIDEBAR */
  .pm-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .pm-sidebar-overlay.open { display: block; }
  .pm-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border: 1px solid #7A7A7A;
  }
  .pm-sidebar.open { transform: translateX(0); }
  .pm-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .pm-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .pm-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pm-sidebar-nav { flex: 1; overflow-y: auto; }
  .pm-sidebar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .pm-sidebar-row:hover { background: #fafafa; }
  .pm-sidebar-row.active { color: #000000; font-weight: 400; }
  .pm-sidebar-chevron {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-right: 2px solid #888;
    border-bottom: 2px solid #888;
    transform: rotate(45deg) translateY(-2px);
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  .pm-sidebar-chevron.open { transform: rotate(-135deg) translateY(-2px); }
  .pm-sidebar-subitems { border-bottom: 1px solid #efefef; }
  .pm-sidebar-subitem {
    display: block;
    padding: 8px 59px 8px 46px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #202020;
    text-decoration: none;
    border-bottom: 0.7px solid #EB2019;
    cursor: pointer;
  }
  .pm-sidebar-subitem:last-child { }
  .pm-sidebar-subitem:hover { background: #fafafa; }
  .pm-sidebar-subitem.active { color: #B91E1A; font-weight: 400; }

  /* BREADCRUMB */
  .pm-breadcrumb { padding: 60px 0 0 0; }
  .pm-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .pm-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .pm-bc-item:hover { color: #EB2019; }
  .pm-bc-item.active { color: #202020; }
  .pm-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* INNER */
  .pm-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* DIVIDER */
  .pm-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px 102px 0px 102px;
  }
  .pm-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }
  .pm-divider-slim {
    max-width: 1600px;
    margin: 0 auto;
    padding: 60px 102px 0 102px;
  }
  .pm-divider-slim hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* SCROLL ANCHOR */
  .pm-anchor { scroll-margin-top: 180px; }

  /* CONTENT */
  .pm-section-content { padding: 80px 0 0 0; }
  .pm-content-grid {
    display: flex;
    gap: 80px;
    align-items: center;
  }
  .pm-content-left { flex: 0 0 766px; }

  .pm-img-col {
    flex: 1;
    align-self: stretch;
    background: #F5F5F5;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pm-img-wrap {
    width: 100%;
    height: 100%;
    max-height: 650px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pm-product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  /* typography */
  .pm-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
    line-height: 120%;
  }
  .pm-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .pm-tag {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #EB2019;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 16px;
  }
  .pm-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 140%;
  }
  .pm-para + .pm-para { margin-top: 14px; }
  .pm-features-tag {
    display: inline-flex;
    align-items: stretch;
    margin: 34px 0 34px 0;
  }
  .pm-features-tag-bar {
    width: 10px;
    background: #EB2019;
    flex-shrink: 0;
  }
  .pm-features-tag-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #202020;
    background: #FFE6E5;
    padding: 18px 27px;
  }
  .pm-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .pm-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .pm-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  /* ══ RESPONSIVE 768px ══ */
  @media (max-width: 768px) {
    .pm-hero-bg        { display: block; }
    .pm-subnav         { top: 70px; }
    .pm-anchor         { scroll-margin-top: 110px; }
    .pm-subnav-inner   { padding: 0 16px; overflow-x: auto; }
    .pm-subnav-link    { padding: 16px 14px; font-size: 13px; }
    .pm-hero              { height: 300px; }
    .pm-hero-content      { padding: 0 32px; }
    .pm-hero-title        { font-size: 26px; }
    .pm-breadcrumb        { padding: 28px 0 0 0; }
    .pm-breadcrumb-inner  { padding: 0 24px; }
    .pm-inner             { padding: 0 24px; }
    .pm-divider           { padding: 0px 32px 0px 32px; }
    .pm-divider:last-child { display: none; }
    .pm-divider-slim      { padding: 20px 24px 0 24px; }
    .pm-section-content   { padding: 40px 0 0 0; }
    .pm-content-grid      { flex-direction: column-reverse !important; gap: 30px; }
    .pm-content-left      { flex: none; width: 100%; }
    .pm-features-tag      { margin: 24px 0 24px 0; }
    .pm-features-tag-text { font-size: 14px; padding: 14px 24px; }
    .pm-img-col           { min-height: 260px; width: 100%; }
    .pm-img-wrap          { max-height: 450px; }
    .pm-red-title         { font-size: 24px; margin-bottom: 10px; }
    .pm-subtitle          { font-size: 18px; margin-bottom: 10px; }
    .pm-para              { font-size: 14px; }
    .pm-para + .pm-para   { margin-top: 10px; }
    .pm-features-list li  { font-size: 14px; }
    .pm-content-grid:last-child { margin-bottom: 40px !important; }
  }

  /* ══ RESPONSIVE 480px ══ */
  @media (max-width: 480px) {
    .pm-subnav           { display: none; }
    .pm-mobile-bar       { display: flex; height: 46px; }
    .pm-sidebar-header   { height: 46px; }
    .pm-anchor           { scroll-margin-top: 80px; }
    .pm-hero-bg          { display: none; }
    .pm-hero-bg-mobile   { display: block; }
    .pm-hero             { height: 370px; }
    .pm-hero-content     { padding: 0 16px; justify-content: flex-start; padding-top: 76px; }
    .pm-hero-title       { font-size: 22px; }
    .pm-breadcrumb       { padding: 30px 0 0 0; }
    .pm-breadcrumb-inner { padding: 0 16px; gap: 6px; }
    .pm-bc-item          { font-size: 14px; }
    .pm-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .pm-inner            { padding: 0 16px; }
    .pm-divider          { padding: 0px 16px; }
    .pm-divider-slim     { padding: 30px 16px 0 16px; }
    .pm-section-content  { padding: 60px 0 0 0; }
    .pm-section-content:last-child { padding: 60px 0 0px 0; }
    .pm-divider:last-child { display: none; }
    .pm-content-grid:last-child { margin-bottom: 60px !important; }
    .pm-content-grid     { gap: 30px; flex-direction: column-reverse !important; }
    .pm-img-wrap         { max-height: 260px; }
    .pm-red-title        { font-size: 20px; margin-bottom: 20px; }
    .pm-subtitle         { font-size: 16px; margin-bottom: 20px; }
    .pm-para             { font-size: 14px; }
    .pm-features-tag      { margin: 20px 0 20px 0; }
    .pm-features-list li { font-size: 14px; }
  }
`;

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const SUBNAV = [
  {
    label: "HP Series",
    chevron: true,
    href: "/power-surveillance/hp-series",
    children: [
      { label: "HP SERIES (1 KVA To 3 KVA ONLINE UPS)", href: "/power-surveillance/hp-series#hp-product-1" },
      { label: "HP SERIES (6 KVA To 10 KVA)",           href: "/power-surveillance/hp-series#hp-product-2" },
      { label: "HP SERIES (10 KVA To 20 KVA)",          href: "/power-surveillance/hp-series#hp-product-3" },
    ],
  },
  { label: "Prime & Master Series", chevron: false, active: true, href: "/power-surveillance/prime-master-series" },
  {
    label: "Liferaft Modular",
    chevron: true,
    href: "/power-surveillance/liferaft-modular",
    children: [
      { label: "Liferaft Modular 25kVA To 400kVA", href: "/power-surveillance/liferaft-modular#lm-product-1" },
      { label: "Liferaft Modular 25kVA To 600kVA", href: "/power-surveillance/liferaft-modular#lm-product-2" },
    ],
  },
  { label: "Power+ Series", chevron: false, href: "/power-surveillance/power-plus-series" },
  { label: "Liferaft",      chevron: false, href: "/power-surveillance/liferaft" },
  {
    label: "Star+ Tx Series",
    chevron: true,
    href: "/power-surveillance/star-tx-series",
    children: [
      { label: "STAR Tx SERIES (6 KVA – 40 KVA)",   href: "/power-surveillance/star-tx-series#st-product-1" },
      { label: "STAR+ Tx SERIES (10 KVA – 300 KVA)", href: "/power-surveillance/star-tx-series#st-product-2" },
    ],
  },
  { label: "Star+ Series",                                   chevron: false, href: "/power-surveillance/star-plus-series" },
  { label: "Star+ Series Microcontroller Based Stabilizers", chevron: false, href: "/power-surveillance/star-plus-series-microcontroller-stabilizers" },
];

const PRODUCTS = [
  {
    id: 1,
    anchor: "pm-product-1",
    title:   "PRIME & MASTER SERIES",
    subtitle: "( Prime 6kVA To 40kVA ) 1:1 & 3:1\n(Master 10kVA To 400kVA) 3:3",
    tag:     "IGBT RECTIFIER DSP CONTROL",
    paras: [
      "Ador Prime & master series are true online, double conversion UPS systems manufactured with the state of the art, PWM and IGBT technology, with In built Isolations Transformer for producing microprocessor controlled pure sinewave output to critical load Like Machine load",
    ],
    features: [
      "DSP Based True Online Double Conversion UPS system.",
      "PWM AND IGBT Technology,",
      "Fully Microprocessor based,",
      "Pure Sine wave output.",
      "Regenerative back feed protection.",
      "High overall Efficiency.",
      "Inbuilt Static switch & LCD Display.",
      "Inbuilt Isolation Transformer at output side.",
      "Customized input & output voltage ranges,",
      "Output short circuit and overload protection",
      "Design for industrial application i.e. machine load.",
    ],
    imgRight: true,
    imgSrc: PrimeImg,
  },
];

/* ── SubnavItem — position:absolute dropdown, hover ── */
function SubnavItem({ item }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <div className="pm-subnav-item">
        <a href={item.href || "#"} className={`pm-subnav-link${item.active ? " pm-active" : ""}`}>
          {item.label}
        </a>
      </div>
    );
  }

  return (
    <div
      className="pm-subnav-item"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <a href={item.href || "#"} className={`pm-subnav-link${item.active ? " pm-active" : ""}`}>
        {item.label}
        <span className={`pm-subnav-chevron${open ? " open" : ""}`} />
      </a>
      {open && (
        <div className="pm-subnav-dropdown">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`pm-subnav-dropdown-item${child.active ? " pm-dd-active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  scrollTo(child.anchor);
                }
                setOpen(false);
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

/* ── SidebarRow ── */
function SidebarRow({ item, onClose }) {
  const [open, setOpen] = useState(false);

  if (!item.chevron || !item.children?.length) {
    return (
      <a href={item.href || "#"} className={`pm-sidebar-row${item.active ? " active" : ""}`} onClick={onClose}>
        {item.label}
      </a>
    );
  }

  return (
    <>
      <button
        className={`pm-sidebar-row${item.active ? " active" : ""}`}
        onClick={() => setOpen(o => !o)}
      >
        {item.label}
        <span className={`pm-sidebar-chevron${open ? " open" : ""}`} />
      </button>
      {open && (
        <div className="pm-sidebar-subitems">
          {item.children.map((child, i) => (
            <a
              key={i}
              href={child.href || `#${child.anchor}`}
              className={`pm-sidebar-subitem${child.active ? " active" : ""}`}
              onClick={(e) => {
                if (child.anchor && !child.href) {
                  e.preventDefault();
                  onClose();
                  setTimeout(() => scrollTo(child.anchor), 320);
                } else {
                  onClose();
                }
              }}
            >
              {child.label}
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default function PrimeMasterSeries() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        setTimeout(tryScroll, 100);
      }
    };
    const timer = setTimeout(tryScroll, 300);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <style>{CSS}</style>

      {/* HERO */}
      <div className="pm">
        <section className="pm-hero">
          <img className="pm-hero-bg" src={HeroBgImg} alt="" />
          <img className="pm-hero-bg-mobile" src={HeroMobileImg} alt="" />
          <div className="pm-hero-content">
            <h1 className="pm-hero-title">
              UNINTERRUPTED <em>POWER</em>,<br />
              UNMATCHED <em>VISION</em>
            </h1>
          </div>
        </section>
      </div>

      {/* SUBNAV outside .pm */}
      <nav className="pm-subnav" aria-label="Product categories">
        <div className="pm-subnav-inner">
          {SUBNAV.map((item, i) => (
            <SubnavItem key={i} item={item} />
          ))}
        </div>
      </nav>

      {/* MOBILE BAR outside .pm */}
      <div className="pm-mobile-bar">
        <span className="pm-mobile-bar-title">Prime &amp; Master Series</span>
        <button className="pm-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      {/* MOBILE SIDEBAR */}
      <div
        className={`pm-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`pm-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="pm-sidebar-header">
          <span className="pm-sidebar-header-title">Prime &amp; Master Series</span>
          <button className="pm-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="pm-sidebar-nav">
          {SUBNAV.map((item, i) => (
            <SidebarRow key={i} item={item} onClose={() => setSidebarOpen(false)} />
          ))}
        </nav>
      </div>

      {/* REST OF PAGE */}
      <div className="pm">
        <nav className="pm-breadcrumb" aria-label="Breadcrumb">
          <div className="pm-breadcrumb-inner">
            <a href="/" className="pm-bc-item">Home</a>
            <span className="pm-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <a href="#" className="pm-bc-item">Business</a>
            <span className="pm-bc-sep"><img src={BcSepIcon} alt="" /></span>
            <span className="pm-bc-item active">Power &amp; Surveillance</span>
          </div>
        </nav>

        <div className="pm-divider-slim"><hr /></div>

        {PRODUCTS.map((product) => (
          <React.Fragment key={product.id}>
            <div id={product.anchor} className="pm-anchor" />
            <section className="pm-section-content">
              <div className="pm-inner">
                <div
                  className="pm-content-grid"
                  style={!product.imgRight ? { flexDirection: "row-reverse" } : {}}
                >
                  <div className="pm-content-left">
                    <h2 className="pm-red-title">{product.title}</h2>
                    <h3 className="pm-subtitle">
                      {product.subtitle.split("\n").map((line, i) => (
                        <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
                      ))}
                    </h3>
                    {product.tag && <p className="pm-tag">{product.tag}</p>}
                    {product.paras.map((p, i) => (
                      <p key={i} className="pm-para">{p}</p>
                    ))}
                    <div className="pm-features-tag">
                      <div className="pm-features-tag-bar" />
                      <span className="pm-features-tag-text">Features</span>
                    </div>
                    <ul className="pm-features-list">
                      {product.features.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                  </div>

                  <div className="pm-img-col">
                    <div className="pm-img-wrap">
                      {product.imgSrc &&
                        <img className="pm-product-img" src={product.imgSrc} alt={product.title} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="pm-divider"><hr /></div>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}